module.exports = __webpack_public_path__ + "static/media/A_GD_Holz_Merkblatt_Lieferanten_CHI_v1.1.736e65e5.pdf";